import AnimatedLogo from '@passkeys/ui/animated-logo';
import Icon from '@passkeys/ui/icon';
import Text from '@passkeys/ui/text';

import exodus from '@/ui/exodus';
import { actions } from '@/ui/flux';
import { getMobileOS, MobileOS } from '@/ui/utils/navigator';

const IosInstructions = () => (
  <>
    In your browser menu, tap the{' '}
    <span className="text-[#387CF6]">
      share icon{' '}
      <Icon
        className="inline align-text-top"
        size={16}
        name="arrow-up-from-square-apple"
      />
    </span>{' '}
    and choose 'Add to Home Screen' in the options.
  </>
);

const AndroidInstructions = () =>
  "In your browser menu, tap the three-dot icon and select 'Add to Homescreen' from the options.";

const instructionsByOs = {
  [MobileOS.Ios]: IosInstructions,
  [MobileOS.Android]: AndroidInstructions,
  none: () => null,
};

const InstallModal = () => {
  const Instructions = instructionsByOs[getMobileOS() ?? 'none'];

  return (
    <div className="flex flex-col items-center px-4">
      <AnimatedLogo
        animationDelay={400}
        width={160}
        iconSize={64}
        iconName="arrow-down-to-line"
        className="mb-8"
      />
      <Text align="center" size={21} className="center mb-3 font-bold">
        Add Passkeys to your Home Screen
      </Text>
      <Text align="center" size={16} className="font-normal">
        <Instructions />
      </Text>
    </div>
  );
};

const showInstallModal = () =>
  actions.modal.show({
    reactContent: <InstallModal />,
    onClose: () => exodus.pwa.hideInstallModal(),
  });

export default showInstallModal;
